<template>
    <v-simple-table>
        <tbody v-if="value">
            <tr>
                <th>Code</th>
                <td>{{ value.code }}</td>
            </tr>
            <tr>
                <th>Account Name</th>
                <td>{{ value.name }}</td>
            </tr>
            <tr>
                <th>Currency</th>
                <td>{{ value.currency ? value.currency.display_name : null }}</td>
            </tr>
            <tr>
                <th>Supplier</th>
                <td>
                    <v-btn v-if="value.supplier&&hasPermission(perm.supplier.read)" icon @click="supplierNavigate(value.supplier)">
                        <v-icon>mdi-menu-right</v-icon>
                    </v-btn>
                    {{ value.supplier ? value.supplier.display_name : null }}
                </td>
            </tr>
            <tr>
                <th>Ledger Payable</th>
                <td>{{ value.ledger_payable ? value.ledger_payable.display_name : null }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import { mapGetters } from 'vuex';
import permissions from './../../data/permissions';
export default {
    name: "SupplierAccount",
    props: {
        value: Object
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        supplierNavigate(supplier){
            this.$router.push({ name: "SupplierDisplay", params: { id: supplier.id} })
        }
    }
}
</script>

<style>

</style>